
      var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsTv = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "icons-tv_983e84d16b4d2ebc__a",
  width: "130.6%",
  height: "133.1%",
  x: "-15.2%",
  y: "-16.5%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "SourceAlpha",
  result: "shadowBlurInner1",
  stdDeviation: 1.5
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 3,
  dy: 2,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  k2: -1,
  k3: 1,
  operator: "arithmetic",
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowInnerInner1",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"
})), /*#__PURE__*/React.createElement("path", {
  id: "icons-tv_983e84d16b4d2ebc__b",
  d: "M29.71 29.002c.181-.697-1.095-2.99-2.026-4.862-.787-1.597-1.515-2.95-2.8-5.275-.356-.657-1.236-2.23-1.665-3.072-.388-.75-.585-1.292-.687-1.515-.217-.471-.186-.786.026-1.24.218-.445.792-1.169 1.736-2.044.169-.16.893-.785 1.643-1.38 1.475-1.165 3.553-2.693 4.19-3.44.472-.564.634-1.096.286-1.312-.449-.27-1.237-.3-3.536.012-2.668.361-5.45 1-7.57 1.076-.531.02-1.282-.013-1.88-.432-.447-.313-.857-1.06-1.465-2.166-.558-1.017-.85-1.373-1.291-1.351-.35.023-.712.135-1.096.56-.432.475-.924 1.413-1.701 2.826-1.468 2.66-2.566 2.845-3.516 3.314-.246.125-2.415.809-4.007 1.346-.795.264-1.423.522-1.9.768-.416.22-.47.596-.23.877 0 0 .066.211 1.409.919.288.149.662.34 1.035.549.715.405 1.4.947 1.396 1.804-.01.781-.211 1.525-1.111 3.684-.386.908-.818 1.857-1.258 2.869-.71 1.61-1.405 3.327-1.928 4.628-.55 1.36-.79 1.982-.762 2.298.023.154.227.253.442.172.79-.31 2.367-1.585 3.26-2.257.657-.487 3.132-2.466 4.954-3.759 1.3-.915 2.348-1.524 3.413-1.773 1.832-.425 3.604.34 7.022 2.647 3.07 2.079 7.283 4.88 8.291 5.421.484.257 1.234.482 1.325.108z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#000",
  filter: "url(#icons-tv_983e84d16b4d2ebc__a)",
  xlinkHref: "#icons-tv_983e84d16b4d2ebc__b"
}), /*#__PURE__*/React.createElement("use", {
  stroke: "#FFF",
  strokeWidth: 2,
  xlinkHref: "#icons-tv_983e84d16b4d2ebc__b"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\r\n    <defs>\r\n        <filter id=\"crum6nluba\" width=\"130.6%\" height=\"133.1%\" x=\"-15.2%\" y=\"-16.5%\" filterUnits=\"objectBoundingBox\">\r\n            <feGaussianBlur in=\"SourceAlpha\" result=\"shadowBlurInner1\" stdDeviation=\"1.5\"/>\r\n            <feOffset dx=\"3\" dy=\"2\" in=\"shadowBlurInner1\" result=\"shadowOffsetInner1\"/>\r\n            <feComposite in=\"shadowOffsetInner1\" in2=\"SourceAlpha\" k2=\"-1\" k3=\"1\" operator=\"arithmetic\" result=\"shadowInnerInner1\"/>\r\n            <feColorMatrix in=\"shadowInnerInner1\" values=\"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0\"/>\r\n        </filter>\r\n        <path id=\"jb7vp8i50b\" d=\"M29.71 29.002c.181-.697-1.095-2.99-2.026-4.862-.787-1.597-1.515-2.95-2.8-5.275-.356-.657-1.236-2.23-1.665-3.072-.388-.75-.585-1.292-.687-1.515-.217-.471-.186-.786.026-1.24.218-.445.792-1.169 1.736-2.044.169-.16.893-.785 1.643-1.38 1.475-1.165 3.553-2.693 4.19-3.44.472-.564.634-1.096.286-1.312-.449-.27-1.237-.3-3.536.012-2.668.361-5.45 1-7.57 1.076-.531.02-1.282-.013-1.88-.432-.447-.313-.857-1.06-1.465-2.166-.558-1.017-.85-1.373-1.291-1.351-.35.023-.712.135-1.096.56-.432.475-.924 1.413-1.701 2.826-1.468 2.66-2.566 2.845-3.516 3.314-.246.125-2.415.809-4.007 1.346-.795.264-1.423.522-1.9.768-.416.22-.47.596-.23.877 0 0 .066.211 1.409.919.288.149.662.34 1.035.549.715.405 1.4.947 1.396 1.804-.01.781-.211 1.525-1.111 3.684-.386.908-.818 1.857-1.258 2.869-.71 1.61-1.405 3.327-1.928 4.628-.55 1.36-.79 1.982-.762 2.298.023.154.227.253.442.172.79-.31 2.367-1.585 3.26-2.257.657-.487 3.132-2.466 4.954-3.759 1.3-.915 2.348-1.524 3.413-1.773 1.832-.425 3.604.34 7.022 2.647 3.07 2.079 7.283 4.88 8.291 5.421.484.257 1.234.482 1.325.108z\"/>\r\n    </defs>\r\n    <g fill=\"none\" fill-rule=\"evenodd\">\r\n        <g>\r\n            <g transform=\"translate(-1371 -298) translate(1371 298)\">\r\n                <use fill=\"#000\" filter=\"url(#crum6nluba)\" xlink:href=\"#jb7vp8i50b\"/>\r\n                <use stroke=\"#FFF\" stroke-width=\"2\" xlink:href=\"#jb7vp8i50b\"/>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons-tv.983e84d16b4d2ebccec3b939113aae38.svg"),
        {
          React: SvgIconsTv,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      